import { render } from "./AppSpinner.vue?vue&type=template&id=4ebb64ee&scoped=true"
import script from "./AppSpinner.vue?vue&type=script&lang=js"
export * from "./AppSpinner.vue?vue&type=script&lang=js"

import "./AppSpinner.vue?vue&type=style&index=0&id=4ebb64ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebb64ee"]])

export default __exports__